import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { MobileTabBar } from './MobileTabBar'
import { CommandPalette } from '@/components/CommandPalette'
import { OmniSoftphone } from '@/components/OmniSoftphone'
import { OfflineBanner } from '@/components/OfflineBanner'
import { TrialBanner } from './TrialBanner'
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { ShortcutsModal } from '@/components/ui/ShortcutsModal'
import { IdleTimeout } from '@/components/IdleTimeout'
import { IncomingChatNotifier } from '@/components/IncomingChatNotifier'
import { useSocket } from '@/lib/socket'
import { Toaster } from 'react-hot-toast'

export function AppShell() {
  useKeyboardShortcuts()
  useSocket()
  return (
    <div className="min-h-screen flex bg-canvas">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TrialBanner />
        <TopBar />
        <OfflineBanner />
        <main className="flex-1 overflow-y-auto bg-canvas pb-16 md:pb-0">
          {/* pb-28 keeps page content clear of the floating softphone (bottom-right). */}
          <div className="max-w-[1280px] mx-auto px-4 md:px-8 pt-7 pb-28">
            <Outlet />
          </div>
        </main>
      </div>
      <MobileTabBar />
      <OmniSoftphone />
      <CommandPalette />
      <ShortcutsModal />
      <IdleTimeout />
      <IncomingChatNotifier />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#1C1917',
            color: '#fff',
            fontSize: 13,
            borderRadius: 12,
            boxShadow: '0 8px 28px -6px rgba(28,25,23,0.28)',
          },
        }}
      />
    </div>
  )
}
